export default {
    excess: 'Franchigia',
    security: 'Deposito cauzionale',
    fuel_policy: 'Politica sul carburante',
    like_for_like: 'Stesso per stesso',
    full_to_full: 'Pieno a pieno',
    mileage: 'Chilometraggio: {mileage} km per noleggio',
    unlimited_mileage: 'Chilometraggio illimitato',
    non_refundable: 'Non rimborsabile',
    free_cancellation_until: 'Cancellazione gratuita fino al {date}',
    cancellation_with_terms: 'Cancellazione {0} in conformità con ',
    t_c_text: 'Termini e condizioni',
    two_free_extras: 'Due extra gratuiti al ritiro',
    glass_tyres_covered: 'Vetro e pneumatici coperti',
    spec_fuel_petrol: 'benzina',
    spec_fuel_petrol_diesel: 'benzina/diesel',
};
